import axios from 'axios';
import { apiHost } from './apiHost';

// Log Aktivitas: mencatat halaman yang DIBUKA pengguna login (POST /log-aktivitas/akses). Server menentukan kalimat dan tingkatnya
// (halaman sensitif = penting). Di sini hanya menyaring halaman yang tidak perlu dan membatasi pengiriman: halaman yang sama paling
// sering sekali per 10 menit. Gagal mengirim tidak pernah mengganggu pemakaian.
export const JEDA_AKSES_MS = 10 * 60 * 1000;

// Halaman publik / teknis: tidak dicatat.
const ABAIKAN = [/^\/$/, /^\/login$/, /^\/order-status/, /^\/status\//, /^\/produktransaksi/];

export const perluDicatat = (pathname) => typeof pathname === 'string' && pathname.length > 0 && !ABAIKAN.some((re) => re.test(pathname));

const terakhir = new Map();
/** true bila halaman ini belum dikirim dalam 10 menit terakhir (sekaligus menandainya). */
export const bolehKirimAkses = (halaman, sekarang = Date.now()) => {
  const t = terakhir.get(halaman);
  if (t && sekarang - t < JEDA_AKSES_MS) return false;
  terakhir.set(halaman, sekarang);
  return true;
};
export const lupakanAkses = () => terakhir.clear(); // dipakai tes dan saat logout

const alamat = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};

/** Catat pembukaan satu halaman web (alamat rute). */
export const kirimCatatAkses = (pathname, platform = 'web') => {
  if (!perluDicatat(pathname) || !bolehKirimAkses(pathname)) return Promise.resolve(false);
  try {
    return Promise.resolve(axios.post(`${alamat()}/log-aktivitas/akses`, { halaman: pathname, platform }, { withCredentials: true }))
      .then(() => true)
      .catch(() => false);
  } catch (e) {
    return Promise.resolve(false);
  }
};
